import { useTranslation } from "react-i18next";
import {
  FaEye,
  FaVideo,
  FaThumbsUp,
  FaCreditCard,
  FaFileAlt,
  FaShare,
} from "react-icons/fa";

const DonorCommunityBenefits = () => {
  const { t } = useTranslation("joinDonor");
  const benefits = t("benefits", { returnObjects: true });
  // const wchannel = t("MyDonorDashboard");

  // const handleJoinWhatsApp = () => {
  //   window.open(
  //     "https://whatsapp.com/channel/0029Vb4L7Cz0LKZK3dhU9l09",
  //     "_blank"
  //   );
  // };

  // ✅ Define benefits + WhatsApp CTA as one list
  const benefitItems = [
    { icon: <FaVideo />, text: benefits[0] },
    { icon: <FaThumbsUp />, text: benefits[1] },
    { icon: <FaCreditCard/>, text: benefits[2] },
    { icon: <FaEye />, text: benefits[3] },
    { icon: <FaFileAlt />, text: benefits[4] },
    { icon: <FaShare />, text: benefits[5] }
  ];

  return (
    <div className="relative">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {benefitItems.map((item, index) => (
          <div
            key={index}
            className="group relative p-6 rounded-2xl border transition-all duration-500 transform hover:-translate-y-2 hover:scale-105 cursor-pointer bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border-green-200/50 dark:border-green-700/30 hover:shadow-2xl hover:shadow-green-500/10"
          >
            <div className="relative flex items-start space-x-4 rtl:space-x-reverse">
              <div
                className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center transform transition-transform duration-300 bg-gradient-to-r from-green-500 to-emerald-500 text-white group-hover:rotate-12"
              >
                {item.icon}
              </div>

              <div className="flex-1">
                <p
                  className="text-base md:text-lg font-medium leading-relaxed text-gray-800 dark:text-gray-200"
                >
                  {item.text}
                </p>
              </div>
            </div>

            {/* Accent line */}
            {!item.isCTA && (
              <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            )}
          </div>
        ))}
      </div>


      {/* <div className="group relative p-6 rounded-2xl border transition-all duration-500 transform hover:-translate-y-2 hover:scale-105 cursor-pointer bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border-green-200/50 dark:border-green-700/30 hover:shadow-2xl hover:shadow-green-500/10 mb-10">
        <div className="relative md:flex md:space-x-4 rtl:space-x-reverse">
          <div
            className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center transform transition-transform duration-300 bg-gradient-to-r from-green-500 to-emerald-500 text-white group-hover:rotate-12"
          >
            <FaWhatsapp />
          </div>

          <div className="flex-1">
            <p
              className="text-base md:text-lg font-medium leading-relaxed text-gray-800 dark:text-gray-200"
            >
              {wchannel.join_wc_message}
            </p>
          </div>

            <button
            onClick={handleJoinWhatsApp}
            className="mt-4 inline-flex items-center px-6 py-2 text-sm font-semibold rounded-xl bg-white text-green-600 hover:bg-green-50 shadow-md transition-all duration-300"
            >
            <FaWhatsapp className="w-4 h-4 mr-2" />
            {wchannel.join_now}
            <FaArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>*/}
    </div>
  );
};

export default DonorCommunityBenefits;

